'use client';

import { motion } from 'framer-motion';
const AnimationFadeUp = ({
  children,
  delay = 0,
  style = {
    height: '100%'
  }
}: any) => {
  return <motion.div style={style} initial={{
    y: '100px',
    opacity: 0
  }} viewport={{
    once: true
  }} whileInView={{
    y: 0,
    opacity: 1
  }} transition={{
    delay,
    duration: 0.7
  }} data-sentry-element="unknown" data-sentry-component="AnimationFadeUp" data-sentry-source-file="AnimationFadeUp.tsx">
      {children}
    </motion.div>;
};
export default AnimationFadeUp;